let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("29ai5")).then(() => parcelRequire('dRYXQ'));